import {ISerializable} from "../../../typescript-plugin/entities/ISerializable";

export class Contact implements ISerializable{
    public name:string;
    public email:string;
    public message:string;
    public token:string;

    constructor(){
        this.Reset();
    }

    public Reset(){
        this.email = "";
        this.name = "";
        this.message = "";
        this.token = "";
    }

    public Deserialize(data: {}): void {
        this.name = data['name'];
        this.email = data['email'];
        this.message = data['message'];
        this.token = data['token'];
    }

    public Serialize(): {} {
        return {
            name: this.name,
            email: this.email,
            message: this.message,
            token: this.token
        };
    }

    public AsFake():Contact{
        this.name = "John Smith";
        this.email = "john.smith@gmail.com";
        this.message = "Message";
        return this;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/contact/Contact.ts